const dasheriseCharsRegExp = /(%[0-9]+|[^a-z0-9/-]+)/g;
const trailingSlashRegExp = /[/-]$/;
const removeSpecialCharacters = /[']|[!+]$/;
const addressRegExp = /^(https?:\/\/[^/]+)([^?]+)([?].*)?$/;

const matchChars = (path) => {
    // remove accents, swap ñ for n, etc
    const from = "åàáãäâèéëêìíïîòóöôùúüûñç";
    const to = "aaaaaaeeeeiiiioooouuuunc";

    return path
        .split("")
        .map((char) => {
            const position = from.indexOf(char);
            return position > 0 ? to.charAt(position) : char;
        })
        .join("");
};

function normalizePath(path, defaultPath = "/") {
    if (typeof path !== "string") {
        return path;
    }

    const result = matchChars(path.toLowerCase())
        .replace(removeSpecialCharacters, "")
        .replace(dasheriseCharsRegExp, "-")
        .replace(trailingSlashRegExp, "");

    return result || defaultPath;
}

// used to format urls for metatag's canonicals
function normalizeURL(url) {
    if (typeof url !== "string") {
        return url;
    }

    const matches = addressRegExp.exec(url);
    if (!matches) {
        return url;
    }

    const [_, address, path, querystring = ""] = matches;
    return `${address}${normalizePath(path)}${querystring}`;
}

/** @deprecated This seems like a duplicate of getAdDataFromSlug */
function getBrandNameFromSlug(merk, brandsList, model) {
    const brandMatch = merk.map((name) => brandsList[name]).filter((v) => !!v);

    if (brandMatch.length > 0) {
        return { otherMerkIds: brandMatch };
    }

    if (model.length > 0) {
        // for the cases when redirected from absent vpd url and brand has multiple words
        const modelSplited = model[0].split("-");

        let i;
        let correctedMerkName = merk[0];

        // eslint-disable-next-line no-plusplus
        for (i = 0; i < modelSplited.length; i++) {
            correctedMerkName = `${correctedMerkName}-${modelSplited[i]}`;

            if (brandsList[correctedMerkName]) {
                const correctedModelName = modelSplited.slice(i + 1).join("-");
                return { otherMerkIds: [brandsList[correctedMerkName]], correctedModelName };
            }
        }
    }

    return { otherMerkIds: [] };
}

module.exports = {
    normalizePath,
    normalizeURL,
    getBrandNameFromSlug
};
